<template>
  <v-layout row justify-center style="margin: 8px">
    <v-btn v-for="item in icons" :key="item.name"
      icon medium
      :href="item.link" target="_blank">
      <v-icon medium>{{ item.icon }}</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        { icon: 'mdi-github-circle', link: 'https://github.com/gabrielwong159' },
        { icon: 'mdi-linkedin-box', link: 'https://linkedin.com/in/gabrielwong159' },
        { icon: 'mdi-email', link: 'mailto:gabrielwong159@gmail.com' },
        // { icon: 'mdi-file-document', link: '/resume.pdf' },
      ]
    };
  },
};
</script>
